export default __webpack_public_path__ + "static/media/TitilliumWeb-SemiBold.3811e415.ttf";